<template>
  <div class="table-search" data-cy="table-search">
    <img
      class="table-search-icon"
      alt="Search Icon"
      :src="searchIconUrl"
      @click.prevent="onSubmit"
    />
    <input
      class="search-input form-control"
      :placeholder="placeholder"
      :type="type"
      v-model="searchValue"
      :min="min"
      :max="max"
      @keydown.enter.prevent="onSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import searchIconUrl from "@/assets/img/search_icon.png";
import { ref, watchEffect } from "vue";

interface Props {
  value?: string;
  placeholder?: string;
  type?: string;
  min?: number;
  max?: number;
}

const props = withDefaults(defineProps<Props>(), {
  type: "text",
});

const searchValue = ref<string>(props.value ?? "");

const emit = defineEmits<{
  (e: "searchSubmitted", searchValue: string): void;
}>();

const onSubmit = function () {
  console.debug(`TableSearch.vue: onSubmit(), searchValue:`, searchValue.value);
  if (props.min && parseInt(searchValue.value) < props.min)
    searchValue.value = props.min.toString();
  else if (props.max && parseInt(searchValue.value) > props.max)
    searchValue.value = props.max.toString();

  emit("searchSubmitted", searchValue.value);
};
watchEffect(() => {
  searchValue.value = props.value || "";
});
</script>

<style lang="scss">
.table-search {
  .table-search-icon {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 14px;
    opacity: 0.4;
  }
  .search-input {
    box-sizing: border-box;
    width: 100%;
    height: 35px;
    border: 1px solid #ddd;
    box-shadow: none;
    border-radius: 4px;
    padding: 0 8px 0 30px;
  }

  &-btn {
    cursor: pointer;
  }
}
</style>
